import LetterPicture from "./LetterPicture";

export default LetterPicture;
